import {MuWidget} from "mu-widget/lib/MuWidget";
import {SlashTree, SlashTreeNode} from "../SlashTree";

export class UiInlineTreeSelector extends MuWidget
{
	beforeIndex() {
		this.container.classList.add('inline-tree-selector');
		this.muAppendContent(`
			<ul class="inline-tree-selector--path" mu-id="path"><li mu-widget="." mu-template="pathItem"><span mu-id="name"></span></li></ul>
			<ul class="inline-tree-selector--select" mu-id="select"><li mu-widget="." mu-template="selectItem"><span mu-id="name"></span></li></ul>
		`);
		this.muRegisterEvent('select');
	}

	public bind(item: SlashTreeNode) {
		this.ui.select.innerHTML = "";
		this.ui.path.innerHTML = "";
		for(const subItem of item.items) {
			this.muWidgetFromTemplate("selectItem", "select", {
				name_click: () => {
					this.bind(subItem);
					this.muDispatchEvent('select', subItem);
				},
				afterIndex: function () {
					this.ui.name.innerText = subItem.name;
				},
			});
		}
		let it : SlashTreeNode|null = item;
		while(it) {
			if (it.parent !== null) {
				const currIt = it;
				this.muWidgetFromTemplate("pathItem", "path", {
					name_click: () => {
						// @ts-ignore
						this.bind(currIt.parent);
						this.muDispatchEvent('select', currIt.parent);
					},
					afterIndex: function () {
						this.ui.name.innerText = currIt.name;
					}
				}, 'first');
			}
			it = it.parent;
		}
	}

}